import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // We handle this via SPA route changes
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    loaded: (ph) => {
      // Respect cookie consent — check if analytics is allowed
      const consent = localStorage.getItem('cookie-consent');
      if (consent) {
        const parsed = JSON.parse(consent);
        if (!parsed.analytics) {
          ph.opt_out_capturing();
        }
      }
    },
  });

  initialized = true;
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, properties);
}

export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

export function capturePageView() {
  if (!POSTHOG_KEY) return;
  posthog.capture('$pageview');
}

/**
 * Call when cookie consent changes to opt in/out of PostHog tracking.
 */
export function updatePostHogConsent(analyticsAllowed: boolean) {
  if (!POSTHOG_KEY) return;
  if (analyticsAllowed) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}

export { posthog };
